// // src/components/HRComponents/ExpoLeadsList.js
// import React, { useState, useEffect, useCallback } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { FaArrowLeft } from 'react-icons/fa';
// import { Search, Filter, X, User, Mail, Phone, Building, MapPin, Calendar, FileText, MessageCircle } from 'lucide-react';
// import { toast } from 'react-toastify';

// import api from "../../common/apiClient";
// import SummaryApi from "../../common/SummaryApi";
// import { UserListSkeleton } from '../../components/SkeletonComponents/UserListSkeleton';
// import SelectDropdown from '../../customStyles/SelectDropdown';
// import ModernTable from '../../components/ui/ModernTable';
// import { formatDateTime } from '../../helpers/formatDateTime';

// const LEAD_STATUS_OPTIONS = [
//   { label: 'All Status', value: '' },
//   { label: 'Open', value: 'OPEN' },
//   { label: 'Contacted', value: 'CONTACTED' },
//   { label: 'Converted', value: 'CONVERTED' },
//   { label: 'Lost', value: 'LOST' },
// ];

// const ExpoLeadsList = () => {
//   const { expoId } = useParams(); // Retrieves optional expoId filter from route params
//   const navigate = useNavigate();
  
//   const [leads, setLeads] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [loading, setLoading] = useState(true);
  
//   const [searchTerm, setSearchTerm] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);

//   const [showFilters, setShowFilters] = useState(false);
//   const [statusFilter, setStatusFilter] = useState('');

//   // Fetch paginated and filtered expo leads from the backend
//   const fetchLeads = useCallback(async () => {
//     setLoading(true);
//     try {
//       // Build search params dynamically
//       const params = {
//         q: searchTerm || undefined,
//         status: statusFilter || undefined,
//         page: currentPage,
//         limit: itemsPerPage === 'All' ? 1000 : itemsPerPage,
//       };

//       // If viewing leads for a specific expo, pass the ID
//       if (expoId) {
//         params.expoId = expoId;
//       }

//       // API call to fetch leads list
//       const res = await api.get(SummaryApi.getAllExpoLeads?.url || `${process.env.REACT_APP_BACKEND_URL}/api/expo-lead/view-all`, { params });
      
//       if (res.data.success) {
//         setLeads(res.data.data || []);
//         // Accessing pagination object structure from your response
//         setTotal(res.data.pagination?.total || 0);
//       }
//     } catch (error) {
//       toast.error('Failed to load captured expo leads');
//       console.error('Leads fetch error:', error);
//     } finally {
//       setLoading(false);
//     }
//   }, [expoId, searchTerm, statusFilter, currentPage, itemsPerPage]);

//   useEffect(() => {
//     fetchLeads();
//   }, [fetchLeads]);

//   const handleViewDetails = (row) => navigate(`view/${row._id}`);

//   // Define table columns based on your corrected lead JSON data
//   const columns = [
//     {
//       label: 'Lead Details',
//       key: 'fullName',
//       render: (row) => (
//         <div className="flex items-center min-w-[220px]">
//           <div className="w-9 h-9 rounded-lg bg-red-50 flex items-center justify-center flex-shrink-0">
//             <User className="h-4 w-4 text-red-500" />
//           </div>
//           <div className="ml-3">
//             <div className="text-sm font-semibold text-gray-900">{row.fullName}</div>
//             <div className="text-[10px] text-gray-400 font-bold tracking-wider">{row.leadNumber}</div>
//           </div>
//         </div>
//       ),
//     },
//     {
//       label: 'Contact Info',
//       key: 'contact',
//       render: (row) => (
//         <div className="space-y-1 min-w-[180px]">
//           <div className="flex items-center gap-1.5 text-xs text-gray-600">
//             <Mail className="h-3.5 w-3.5 text-gray-400 shrink-0" />
//             <span className="truncate max-w-[150px]" title={row.email}>{row.email || '-'}</span>
//           </div>
//           <div className="flex items-center gap-1.5 text-xs text-gray-600">
//             <Phone className="h-3.5 w-3.5 text-gray-400 shrink-0" />
//             <span>{row.mobile || '-'}</span>
//             {row.isWhatsAppSame && (
//               <span className="inline-flex items-center text-[9px] font-bold text-emerald-600 bg-emerald-50 px-1 py-0.5 rounded border border-emerald-100 gap-0.5" title="WhatsApp Number">
//                 <MessageCircle className="h-2.5 w-2.5" /> WA
//               </span>
//             )}
//           </div>
//         </div>
//       ),
//     },
//     {
//       label: 'Organization / Designation',
//       key: 'companyOrSchool',
//       render: (row) => (
//         <div className="space-y-0.5">
//           <div className="text-xs font-semibold text-gray-800 flex items-center gap-1">
//             <Building className="h-3 w-3 text-gray-400 shrink-0" />
//             <span>{row.companyOrSchool || '-'}</span>
//           </div>
//           <div className="text-[11px] text-gray-500 capitalize">{row.designation || '-'}</div>
//         </div>
//       ),
//     },
//     {
//       label: 'City',
//       key: 'city',
//       render: (row) => (
//         <div className="flex items-center gap-1 text-sm text-gray-700">
//           <MapPin className="h-3.5 w-3.5 text-gray-400" />
//           <span>{row.city || '-'}</span>
//         </div>
//       ),
//     },
//     {
//       label: 'Source Event',
//       key: 'expoId',
//       render: (row) => (
//         <span className="inline-flex items-center px-2 py-0.5 rounded bg-gray-50 text-gray-600 text-xs font-semibold border border-gray-150">
//           {row.expoId?.expoName || row.source || '-'}
//         </span>
//       ),
//     },
//     {
//       label: 'Status',
//       key: 'status',
//       render: (row) => (
//         <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wide border ${
//           row.status === 'OPEN' 
//             ? 'bg-blue-50 text-blue-700 border-blue-100' 
//             : row.status === 'CONVERTED'
//             ? 'bg-emerald-50 text-emerald-700 border-emerald-100'
//             : 'bg-gray-100 text-gray-600 border-gray-250'
//         }`}>
//           {row.status || 'OPEN'}
//         </span>
//       ),
//     },
//     {
//       label: 'Date Captured',
//       key: 'createdAt',
//       render: (row) => (
//         <div className="flex items-center gap-1.5 text-xs text-gray-600">
//           <Calendar className="h-3.5 w-3.5 text-gray-400 shrink-0" />
//           <span>{row.createdAt ? formatDateTime(row.createdAt, false) : '-'}</span>
//         </div>
//       ),
//     },
//   ];

//   // Table actions configuration
//   const tableActions = [
//     { label: 'View Full Profile', icon: <FileText className="h-4 w-4" />, onClick: handleViewDetails },
//   ];

//   if (loading && leads.length === 0) return <UserListSkeleton />;

//   return (
//     <div className="p-4 animate-fadeIn">
//       {/* Header section with page title */}
//       <div className="mb-6 flex flex-row justify-between items-center gap-2">
//         <div className="flex items-center gap-2">
//           <button
//             onClick={() => navigate(-1)}
//             className="rounded-lg bg-red-50 border border-red-100 hover:border-primary text-textPrimary hover:text-primary p-1.5 sm:p-2 transition-colors"
//           >
//             <FaArrowLeft className="w-4 h-4 sm:w-5 sm:h-5" />
//           </button>
//           <div>
//             <h1 className="text-lg sm:text-2xl font-bold text-gray-900 whitespace-nowrap">
//               Captured Expo Leads
//             </h1>
//             <p className="text-xs text-gray-500 hidden sm:block">Track and follow-up on your offline registrations campaign.</p>
//           </div>
//         </div>
//       </div>

//       {/* Search and Filters section */}
//       <div className="mb-6 space-y-4">
//         <div className="flex flex-col sm:flex-row gap-4">
//           <div className="relative flex-1">
//             <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
//             <input
//               type="text"
//               placeholder="Search leads by name, email or number..."
//               value={searchTerm}
//               onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
//               className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500 outline-none text-sm"
//             />
//           </div>
//           <button
//             onClick={() => setShowFilters(!showFilters)}
//             className={`flex items-center gap-2 px-4 py-2 border rounded-xl transition-colors text-sm font-medium ${
//               showFilters ? 'bg-red-50 border-red-300 text-red-700' : 'bg-white border-gray-300 text-gray-700'
//             }`}
//           >
//             <Filter className="h-4 w-4" /> Filters
//           </button>
//         </div>

//         {/* Filters dropdown container */}
//         {showFilters && (
//           <div className="bg-white p-4 rounded-xl shadow-sm border grid grid-cols-1 sm:grid-cols-2 gap-4 animate-in fade-in slide-in-from-top-2">
//             <SelectDropdown 
//               label="Lead Status" 
//               options={LEAD_STATUS_OPTIONS} 
//               value={statusFilter} 
//               onChange={(v) => { setStatusFilter(v); setCurrentPage(1); }} 
//               valueKey="value" 
//               labelKey="label" 
//             />
            
//             <div className="flex items-end justify-start sm:justify-end pb-1">
//               <button
//                 onClick={() => { setStatusFilter(''); setSearchTerm(''); setCurrentPage(1); }}
//                 className="text-red-650 text-xs font-semibold flex items-center gap-1 hover:underline h-10"
//               >
//                 <X className="h-4 w-4" /> Clear All Filters
//               </button>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Main modern table wrapper */}
//       <ModernTable
//         columns={columns}
//         data={leads}
//         actions={tableActions}
//         selectable={false}
//         stickyColumns={1}
//         pagination={{
//           totalItems: total,
//           itemsPerPage,
//           currentPage,
//           onPageChange: setCurrentPage,
//           onItemsPerPageChange: (val) => { setItemsPerPage(val); setCurrentPage(1); },
//         }}
//       />

//       {/* No records fallback screen */}
//       {!loading && leads.length === 0 && (
//         <div className="bg-white rounded-xl border p-12 text-center mt-4 animate-fadeIn">
//           <User className="h-12 w-12 text-gray-300 mx-auto mb-4" />
//           <h3 className="text-lg font-medium text-gray-900">No leads captured yet</h3>
//           <p className="text-gray-500 text-sm mt-1">Configure your scanners or display your event QR codes for visitors to submit entries.</p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ExpoLeadsList;
// src/components/HRComponents/ExpoLeadsList.js
// import React, { useState, useEffect, useCallback } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { FaArrowLeft } from 'react-icons/fa';
// import { Search, Filter, X, User, Mail, Phone, Building, MapPin, Calendar, FileText, MessageCircle, Download } from 'lucide-react';
// import { toast } from 'react-toastify';

// import api from "../../common/apiClient";
// import SummaryApi from "../../common/SummaryApi";
// import { UserListSkeleton } from '../../components/SkeletonComponents/UserListSkeleton';
// import SelectDropdown from '../../customStyles/SelectDropdown';
// import ModernTable from '../../components/ui/ModernTable';
// import { formatDateTime } from '../../helpers/formatDateTime';

// const LEAD_STATUS_OPTIONS = [
//   { label: 'All Status', value: '' },
//   { label: 'Open', value: 'OPEN' },
//   { label: 'Contacted', value: 'CONTACTED' },
//   { label: 'Converted', value: 'CONVERTED' },
//   { label: 'Lost', value: 'LOST' },
// ];

// const ExpoLeadsList = () => {
//   const { expoId } = useParams();
//   const navigate = useNavigate();
  
//   const [leads, setLeads] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [loading, setLoading] = useState(true);
//   const [exporting, setExporting] = useState(false);
  
//   const [searchTerm, setSearchTerm] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);

//   const [showFilters, setShowFilters] = useState(false);
//   const [statusFilter, setStatusFilter] = useState('');

//   const fetchLeads = useCallback(async () => {
//     setLoading(true);
//     try {
//       const params = {
//         q: searchTerm || undefined,
//         status: statusFilter || undefined,
//         page: currentPage,
//         limit: itemsPerPage === 'All' ? 1000 : itemsPerPage,
//       };

//       if (expoId) {
//         params.expoId = expoId;
//       }

//       const res = await api.get(SummaryApi.getAllExpoLeads?.url || `${process.env.REACT_APP_BACKEND_URL}/api/expo-lead/view-all`, { params });
      
//       if (res.data.success) {
//         setLeads(res.data.data || []);
//         setTotal(res.data.pagination?.total || 0);
//       }
//     } catch (error) {
//       toast.error('Failed to load captured expo leads');
//       console.error('Leads fetch error:', error);
//     } finally {
//       setLoading(false);
//     }
//   }, [expoId, searchTerm, statusFilter, currentPage, itemsPerPage]);

//   useEffect(() => {
//     fetchLeads();
//   }, [fetchLeads]);

//   // Helper to safely format cell values for CSV
//   const cleanCell = (val) => {
//     if (val === undefined || val === null) return '';
//     return String(val).replace(/"/g, '""');
//   };

//   // Maps all specified schema fields to CSV format
//   const convertToCSV = (data) => {
//     const headers = [
//       'Expo Name',
//       'Full Name',
//       'Email',
//       'Mobile',
//       'Company/School',
//       'Designation',
//       'Student Per Classroom',
//       'Total Classes',
//       'ERP Status',
//       'Existing ERP',
//       'City',
//       'Divisions',
//       'Requirement',
//       'Source',
//       'Status',
//         ];

//     const csvRows = [headers.join(',')];

//     data.forEach(row => {
//       const values = [
//         `"${cleanCell(row.expoId?.expoName)}"`,
//         `"${cleanCell(row.fullName)}"`,
//         `"${cleanCell(row.email)}"`,
//         `"${cleanCell(row.mobile)}"`,
//         `"${cleanCell(row.companyOrSchool)}"`,
//         `"${cleanCell(row.designation)}"`,
//         `"${cleanCell(row.studentPerClassroom)}"`,
//         `"${cleanCell(row.totalClasses)}"`,
//         `"${cleanCell(row.erpStatus)}"`,
//         `"${cleanCell(row.existingErp)}"`,
//         `"${cleanCell(row.city)}"`,
//         `"${cleanCell(row.division)}"`,
//         `"${cleanCell(row.requirement)}"`,
//         `"${cleanCell(row.source)}"`,
//         `"${cleanCell(row.status)}"`,
//              ];
//       csvRows.push(values.join(','));
//     });

//     return csvRows.join('\n');
//   };

//   const downloadCSV = (csvContent, fileName) => {
//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.setAttribute('href', url);
//     link.setAttribute('download', fileName);
//     link.style.visibility = 'hidden';
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   const handleExportAll = async () => {
//     setExporting(true);
//     try {
//       const params = {
//         q: searchTerm || undefined,
//         status: statusFilter || undefined,
//         page: 1,
//         limit: 10000, // Fetch a large range to retrieve all entries
//       };

//       if (expoId) {
//         params.expoId = expoId;
//       }

//       const res = await api.get(SummaryApi.getAllExpoLeads?.url || `${process.env.REACT_APP_BACKEND_URL}/api/expo-lead/view-all`, { params });
      
//       if (res.data.success) {
//         const allLeads = res.data.data || [];
//         if (allLeads.length === 0) {
//           toast.info('No data available to export');
//           return;
//         }

//         const csvString = convertToCSV(allLeads);
//         const fileName = `expo_leads_${new Date().toISOString().slice(0, 10)}.csv`;
//         downloadCSV(csvString, fileName);
//         toast.success('All matching leads exported successfully');
//       } else {
//         toast.error('Failed to export data');
//       }
//     } catch (error) {
//       toast.error('An error occurred during export');
//       console.error('Export error:', error);
//     } finally {
//       setExporting(false);
//     }
//   };

//   const handleViewDetails = (row) => navigate(`view/${row._id}`);

//   const columns = [
//     {
//       label: 'Lead Details',
//       key: 'fullName',
//       render: (row) => (
//         <div className="flex items-center min-w-[220px]">
//           <div className="w-9 h-9 rounded-lg bg-red-50 flex items-center justify-center flex-shrink-0">
//             <User className="h-4 w-4 text-red-500" />
//           </div>
//           <div className="ml-3">
//             <div className="text-sm font-semibold text-gray-900">{row.fullName}</div>
//             <div className="text-[10px] text-gray-400 font-bold tracking-wider">{row.leadNumber}</div>
//           </div>
//         </div>
//       ),
//     },
//     {
//       label: 'Contact Info',
//       key: 'contact',
//       render: (row) => (
//         <div className="space-y-1 min-w-[180px]">
//           <div className="flex items-center gap-1.5 text-xs text-gray-600">
//             <Mail className="h-3.5 w-3.5 text-gray-400 shrink-0" />
//             <span className="truncate max-w-[150px]" title={row.email}>{row.email || '-'}</span>
//           </div>
//           <div className="flex items-center gap-1.5 text-xs text-gray-600">
//             <Phone className="h-3.5 w-3.5 text-gray-400 shrink-0" />
//             <span>{row.mobile || '-'}</span>
//             {row.isWhatsAppSame && (
//               <span className="inline-flex items-center text-[9px] font-bold text-emerald-600 bg-emerald-50 px-1 py-0.5 rounded border border-emerald-100 gap-0.5" title="WhatsApp Number">
//                 <MessageCircle className="h-2.5 w-2.5" /> WA
//               </span>
//             )}
//           </div>
//         </div>
//       ),
//     },
//     {
//       label: 'Organization / Designation',
//       key: 'companyOrSchool',
//       render: (row) => (
//         <div className="space-y-0.5">
//           <div className="text-xs font-semibold text-gray-800 flex items-center gap-1">
//             <Building className="h-3 w-3 text-gray-400 shrink-0" />
//             <span>{row.companyOrSchool || '-'}</span>
//           </div>
//           <div className="text-[11px] text-gray-500 capitalize">{row.designation || '-'}</div>
//         </div>
//       ),
//     },
//     {
//       label: 'City',
//       key: 'city',
//       render: (row) => (
//         <div className="flex items-center gap-1 text-sm text-gray-700">
//           <MapPin className="h-3.5 w-3.5 text-gray-400" />
//           <span>{row.city || '-'}</span>
//         </div>
//       ),
//     },
//     {
//       label: 'Source Event',
//       key: 'expoId',
//       render: (row) => (
//         <span className="inline-flex items-center px-2 py-0.5 rounded bg-gray-50 text-gray-600 text-xs font-semibold border border-gray-150">
//           {row.expoId?.expoName || row.source || '-'}
//         </span>
//       ),
//     },
//     {
//       label: 'Status',
//       key: 'status',
//       render: (row) => (
//         <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wide border ${
//           row.status === 'OPEN' 
//             ? 'bg-blue-50 text-blue-700 border-blue-100' 
//             : row.status === 'CONVERTED'
//             ? 'bg-emerald-50 text-emerald-700 border-emerald-100'
//             : 'bg-gray-100 text-gray-600 border-gray-250'
//         }`}>
//           {row.status || 'OPEN'}
//         </span>
//       ),
//     },
//     {
//       label: 'Date Captured',
//       key: 'createdAt',
//       render: (row) => (
//         <div className="flex items-center gap-1.5 text-xs text-gray-600">
//           <Calendar className="h-3.5 w-3.5 text-gray-400 shrink-0" />
//           <span>{row.createdAt ? formatDateTime(row.createdAt, false) : '-'}</span>
//         </div>
//       ),
//     },
//   ];

//   const tableActions = [
//     { label: 'View Full Profile', icon: <FileText className="h-4 w-4" />, onClick: handleViewDetails },
//   ];

//   if (loading && leads.length === 0) return <UserListSkeleton />;

//   return (
//     <div className="p-4 animate-fadeIn">
//       <div className="mb-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
//         <div className="flex items-center gap-2">
//           <button
//             onClick={() => navigate(-1)}
//             className="rounded-lg bg-red-50 border border-red-100 hover:border-primary text-textPrimary hover:text-primary p-1.5 sm:p-2 transition-colors"
//           >
//             <FaArrowLeft className="w-4 h-4 sm:w-5 sm:h-5" />
//           </button>
//           <div>
//             <h1 className="text-lg sm:text-2xl font-bold text-gray-900 whitespace-nowrap">
//               Captured Expo Leads
//             </h1>
//             <p className="text-xs text-gray-500 hidden sm:block">Track and follow-up on your offline registrations campaign.</p>
//           </div>
//         </div>

//         <button
//           onClick={handleExportAll}
//           disabled={exporting || leads.length === 0}
//           className="flex items-center justify-center gap-2 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 disabled:bg-emerald-300 text-white rounded-xl transition-colors text-sm font-semibold shadow-sm w-full sm:w-auto"
//         >
//           <Download className="h-4 w-4" />
//           {exporting ? 'Exporting...' : 'Export All to CSV'}
//         </button>
//       </div>

//       <div className="mb-6 space-y-4">
//         <div className="flex flex-col sm:flex-row gap-4">
//           <div className="relative flex-1">
//             <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
//             <input
//               type="text"
//               placeholder="Search leads by name, email or number..."
//               value={searchTerm}
//               onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
//               className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500 outline-none text-sm"
//             />
//           </div>
//           <button
//             onClick={() => setShowFilters(!showFilters)}
//             className={`flex items-center gap-2 px-4 py-2 border rounded-xl transition-colors text-sm font-medium ${
//               showFilters ? 'bg-red-50 border-red-300 text-red-700' : 'bg-white border-gray-300 text-gray-700'
//             }`}
//           >
//             <Filter className="h-4 w-4" /> Filters
//           </button>
//         </div>

//         {showFilters && (
//           <div className="bg-white p-4 rounded-xl shadow-sm border grid grid-cols-1 sm:grid-cols-2 gap-4 animate-in fade-in slide-in-from-top-2">
//             <SelectDropdown 
//               label="Lead Status" 
//               options={LEAD_STATUS_OPTIONS} 
//               value={statusFilter} 
//               onChange={(v) => { setStatusFilter(v); setCurrentPage(1); }} 
//               valueKey="value" 
//               labelKey="label" 
//             />
            
//             <div className="flex items-end justify-start sm:justify-end pb-1">
//               <button
//                 onClick={() => { setStatusFilter(''); setSearchTerm(''); setCurrentPage(1); }}
//                 className="text-red-650 text-xs font-semibold flex items-center gap-1 hover:underline h-10"
//               >
//                 <X className="h-4 w-4" /> Clear All Filters
//               </button>
//             </div>
//           </div>
//         )}
//       </div>

//       <ModernTable
//         columns={columns}
//         data={leads}
//         actions={tableActions}
//         selectable={false}
//         stickyColumns={1}
//         pagination={{
//           totalItems: total,
//           itemsPerPage,
//           currentPage,
//           onPageChange: setCurrentPage,
//           onItemsPerPageChange: (val) => { setItemsPerPage(val); setCurrentPage(1); },
//         }}
//       />

//       {!loading && leads.length === 0 && (
//         <div className="bg-white rounded-xl border p-12 text-center mt-4 animate-fadeIn">
//           <User className="h-12 w-12 text-gray-300 mx-auto mb-4" />
//           <h3 className="text-lg font-medium text-gray-900">No leads captured yet</h3>
//           <p className="text-gray-500 text-sm mt-1">Configure your scanners or display your event QR codes for visitors to submit entries.</p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ExpoLeadsList;
import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaExchangeAlt } from 'react-icons/fa';
import { 
  Search, Filter, X, User, Mail, Phone, Building, 
  MapPin, Calendar, FileText, MessageCircle, Download, 
  UserCheck 
} from 'lucide-react';
import { toast } from 'react-toastify';

import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";
import { UserListSkeleton } from '../../components/SkeletonComponents/UserListSkeleton';
import SelectDropdown from '../../customStyles/SelectDropdown';
import ModernTable from '../../components/ui/ModernTable';
import { formatDateTime } from '../../helpers/formatDateTime';

const LEAD_STATUS_OPTIONS = [
  { label: 'All Status', value: '' },
  { label: 'Open', value: 'OPEN' },
  { label: 'Contacted', value: 'CONTACTED' },
  { label: 'Converted', value: 'CONVERTED' },
  { label: 'Lost', value: 'LOST' },
];

const ExpoLeadsList = () => {
  const { portalName, expoId } = useParams();
  const navigate = useNavigate();
  
  const [leads, setLeads] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [exporting, setExporting] = useState(false);
  
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [showFilters, setShowFilters] = useState(false);
  const [statusFilter, setStatusFilter] = useState('');

  const fetchLeads = useCallback(async () => {
    setLoading(true);
    try {
      const params = {
        q: searchTerm || undefined,
        status: statusFilter || undefined,
        page: currentPage,
        limit: itemsPerPage === 'All' ? 1000 : itemsPerPage,
      };

      if (expoId) {
        params.expoId = expoId;
      }

      const res = await api.get(SummaryApi.getAllExpoLeads?.url || `${process.env.REACT_APP_BACKEND_URL}/api/expo-lead/view-all`, { params });
      
      if (res.data.success) {
        setLeads(res.data.data || []);
        setTotal(res.data.pagination?.total || 0);
      }
    } catch (error) {
      toast.error('Failed to load captured expo leads');
      console.error('Leads fetch error:', error);
    } finally {
      setLoading(false);
    }
  }, [expoId, searchTerm, statusFilter, currentPage, itemsPerPage]);

  useEffect(() => {
    fetchLeads();
  }, [fetchLeads]);

  // Helper to safely format cell values for CSV
  const cleanCell = (val) => {
    if (val === undefined || val === null) return '';
    return String(val).replace(/"/g, '""');
  };

  // Maps all specified schema fields to CSV format
  const convertToCSV = (data) => {
    const headers = [
      'Expo Name',
      'Full Name',
      'Email',
      'Mobile',
      'Company/School',
      'Designation',
      'Student Per Classroom',
      'Total Classes',
      'ERP Status',
      'Existing ERP',
      'City',
      'Divisions',
      'Requirement',
      'Source',
      'Status',
    ];

    const csvRows = [headers.join(',')];

    data.forEach(row => {
      const values = [
        `"${cleanCell(row.expoId?.expoName)}"`,
        `"${cleanCell(row.fullName)}"`,
        `"${cleanCell(row.email)}"`,
        `"${cleanCell(row.mobile)}"`,
        `"${cleanCell(row.companyOrSchool)}"`,
        `"${cleanCell(row.designation)}"`,
        `"${cleanCell(row.studentPerClassroom)}"`,
        `"${cleanCell(row.totalClasses)}"`,
        `"${cleanCell(row.erpStatus)}"`,
        `"${cleanCell(row.existingErp)}"`,
        `"${cleanCell(row.city)}"`,
        `"${cleanCell(row.division)}"`,
        `"${cleanCell(row.requirement)}"`,
        `"${cleanCell(row.source)}"`,
        `"${cleanCell(row.status)}"`,
      ];
      csvRows.push(values.join(','));
    });

    return csvRows.join('\n');
  };

  const downloadCSV = (csvContent, fileName) => {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', fileName);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExportAll = async () => {
    setExporting(true);
    try {
      const params = {
        q: searchTerm || undefined,
        status: statusFilter || undefined,
        page: 1,
        limit: 10000,
      };

      if (expoId) {
        params.expoId = expoId;
      }

      const res = await api.get(SummaryApi.getAllExpoLeads?.url || `${process.env.REACT_APP_BACKEND_URL}/api/expo-lead/view-all`, { params });
      
      if (res.data.success) {
        const allLeads = res.data.data || [];
        if (allLeads.length === 0) {
          toast.info('No data available to export');
          return;
        }

        const csvString = convertToCSV(allLeads);
        const fileName = `expo_leads_${new Date().toISOString().slice(0, 10)}.csv`;
        downloadCSV(csvString, fileName);
        toast.success('All matching leads exported successfully');
      } else {
        toast.error('Failed to export data');
      }
    } catch (error) {
      toast.error('An error occurred during export');
      console.error('Export error:', error);
    } finally {
      setExporting(false);
    }
  };

  const handleViewDetails = (row) => {
    const targetPortal = portalName ? `/${portalName}` : '';
    navigate(`${targetPortal}/sales/expo-leads/view/${row._id}`);
  };

  // -------------------------------------------------------------
  // CONVERSION REDIRECT LOGIC (Matching OpenLeads.js style)
  // -------------------------------------------------------------
  const handleConvertToVisit = (row) => {
    if (row.status === 'CONVERTED') {
      toast.warning('This lead has already been converted to a Client Visit.');
      return;
    }
    const targetPortal = portalName ? `/${portalName}` : '';
    navigate(`${targetPortal}/sales/leads/convert/${row._id}`);
  };

  const columns = [
    {
      label: 'Lead Details',
      key: 'fullName',
      render: (row) => (
        <div className="flex items-center min-w-[220px]">
          <div className="w-9 h-9 rounded-lg bg-red-50 flex items-center justify-center flex-shrink-0">
            <User className="h-4 w-4 text-red-500" />
          </div>
          <div className="ml-3">
            <div className="text-sm font-semibold text-gray-900">{row.fullName}</div>
            <div className="text-[10px] text-gray-400 font-bold tracking-wider">{row.leadNumber}</div>
          </div>
        </div>
      ),
    },
    {
      label: 'Contact Info',
      key: 'contact',
      render: (row) => (
        <div className="space-y-1 min-w-[180px]">
          <div className="flex items-center gap-1.5 text-xs text-gray-600">
            <Mail className="h-3.5 w-3.5 text-gray-400 shrink-0" />
            <span className="truncate max-w-[150px]" title={row.email}>{row.email || '-'}</span>
          </div>
          <div className="flex items-center gap-1.5 text-xs text-gray-600">
            <Phone className="h-3.5 w-3.5 text-gray-400 shrink-0" />
            <span>{row.mobile || '-'}</span>
            {row.isWhatsAppSame && (
              <span className="inline-flex items-center text-[9px] font-bold text-emerald-600 bg-emerald-50 px-1 py-0.5 rounded border border-emerald-100 gap-0.5" title="WhatsApp Number">
                <MessageCircle className="h-2.5 w-2.5" /> WA
              </span>
            )}
          </div>
        </div>
      ),
    },
    {
      label: 'Organization / Designation',
      key: 'companyOrSchool',
      render: (row) => (
        <div className="space-y-0.5">
          <div className="text-xs font-semibold text-gray-800 flex items-center gap-1">
            <Building className="h-3 w-3 text-gray-400 shrink-0" />
            <span>{row.companyOrSchool || '-'}</span>
          </div>
          <div className="text-[11px] text-gray-500 capitalize">{row.designation || '-'}</div>
        </div>
      ),
    },
    {
      label: 'City',
      key: 'city',
      render: (row) => (
        <div className="flex items-center gap-1 text-sm text-gray-700">
          <MapPin className="h-3.5 w-3.5 text-gray-400" />
          <span>{row.city || '-'}</span>
        </div>
      ),
    },
    {
      label: 'Source Event',
      key: 'expoId',
      render: (row) => (
        <span className="inline-flex items-center px-2 py-0.5 rounded bg-gray-50 text-gray-600 text-xs font-semibold border border-gray-150">
          {row.expoId?.expoName || row.source || '-'}
        </span>
      ),
    },
    {
      label: 'Status',
      key: 'status',
      render: (row) => (
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wide border ${
          row.status === 'OPEN' 
            ? 'bg-blue-50 text-blue-700 border-blue-100' 
            : row.status === 'CONVERTED'
            ? 'bg-emerald-50 text-emerald-700 border-emerald-100'
            : 'bg-gray-100 text-gray-600 border-gray-250'
        }`}>
          {row.status || 'OPEN'}
        </span>
      ),
    },
    {
      label: 'Date Captured',
      key: 'createdAt',
      render: (row) => (
        <div className="flex items-center gap-1.5 text-xs text-gray-600">
          <Calendar className="h-3.5 w-3.5 text-gray-400 shrink-0" />
          <span>{row.createdAt ? formatDateTime(row.createdAt, false) : '-'}</span>
        </div>
      ),
    },
    {
      label: 'Action',
      key: 'convertAction',
      render: (row) => (
        <div>
          {row.status === 'CONVERTED' ? (
            <span className="text-[11px] text-emerald-600 font-semibold flex items-center gap-1">
              <UserCheck className="w-3.5 h-3.5" /> Converted
            </span>
          ) : (
            <button
              onClick={() => handleConvertToVisit(row)}
              className="inline-flex items-center gap-1.5 text-xs font-semibold text-green-700 hover:text-green-800 bg-green-50 hover:bg-green-100 px-2.5 py-1.5 rounded-md border border-green-200 transition-colors"
            >
              <FaExchangeAlt className="w-3 h-3" /> Convert Visit
            </button>
          )}
        </div>
      ),
    }
  ];

  const tableActions = [
    { label: 'View Full Profile', icon: <FileText className="h-4 w-4" />, onClick: handleViewDetails },
    { 
      label: 'Convert Visit', 
      icon: <FaExchangeAlt className="h-3.5 w-3.5 text-green-700" />, 
      onClick: handleConvertToVisit,
      disabled: (row) => row.status === 'CONVERTED'
    },
  ];

  if (loading && leads.length === 0) return <UserListSkeleton />;

  return (
    <div className="p-4 animate-fadeIn">
      <div className="mb-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div className="flex items-center gap-2">
          <button
            onClick={() => navigate(-1)}
            className="rounded-lg bg-red-50 border border-red-100 hover:border-primary text-textPrimary hover:text-primary p-1.5 sm:p-2 transition-colors"
          >
            <FaArrowLeft className="w-4 h-4 sm:w-5 sm:h-5" />
          </button>
          <div>
            <h1 className="text-lg sm:text-2xl font-bold text-gray-900 whitespace-nowrap">
              Captured Expo Leads
            </h1>
            <p className="text-xs text-gray-500 hidden sm:block">Track and follow-up on your offline registrations campaign.</p>
          </div>
        </div>

        <button
          onClick={handleExportAll}
          disabled={exporting || leads.length === 0}
          className="flex items-center justify-center gap-2 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 disabled:bg-emerald-300 text-white rounded-xl transition-colors text-sm font-semibold shadow-sm w-full sm:w-auto"
        >
          <Download className="h-4 w-4" />
          {exporting ? 'Exporting...' : 'Export All to CSV'}
        </button>
      </div>

      <div className="mb-6 space-y-4">
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
            <input
              type="text"
              placeholder="Search leads by name, email or number..."
              value={searchTerm}
              onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500 outline-none text-sm"
            />
          </div>
          <button
            onClick={() => setShowFilters(!showFilters)}
            className={`flex items-center gap-2 px-4 py-2 border rounded-xl transition-colors text-sm font-medium ${
              showFilters ? 'bg-red-50 border-red-300 text-red-700' : 'bg-white border-gray-300 text-gray-700'
            }`}
          >
            <Filter className="h-4 w-4" /> Filters
          </button>
        </div>

        {showFilters && (
          <div className="bg-white p-4 rounded-xl shadow-sm border grid grid-cols-1 sm:grid-cols-2 gap-4 animate-in fade-in slide-in-from-top-2">
            <SelectDropdown 
              label="Lead Status" 
              options={LEAD_STATUS_OPTIONS} 
              value={statusFilter} 
              onChange={(v) => { setStatusFilter(v); setCurrentPage(1); }} 
              valueKey="value" 
              labelKey="label" 
            />
            
            <div className="flex items-end justify-start sm:justify-end pb-1">
              <button
                onClick={() => { setStatusFilter(''); setSearchTerm(''); setCurrentPage(1); }}
                className="text-red-650 text-xs font-semibold flex items-center gap-1 hover:underline h-10"
              >
                <X className="h-4 w-4" /> Clear All Filters
              </button>
            </div>
          </div>
        )}
      </div>

      <ModernTable
        columns={columns}
        data={leads}
        actions={tableActions}
        selectable={false}
        stickyColumns={1}
        pagination={{
          totalItems: total,
          itemsPerPage,
          currentPage,
          onPageChange: setCurrentPage,
          onItemsPerPageChange: (val) => { setItemsPerPage(val); setCurrentPage(1); },
        }}
      />

      {!loading && leads.length === 0 && (
        <div className="bg-white rounded-xl border p-12 text-center mt-4 animate-fadeIn">
          <User className="h-12 w-12 text-gray-300 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900">No leads captured yet</h3>
          <p className="text-gray-500 text-sm mt-1">Configure your scanners or display your event QR codes for visitors to submit entries.</p>
        </div>
      )}
    </div>
  );
};

export default ExpoLeadsList;